import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatPrice } from '@/utils/index'
import { removeFormatNumber } from '@/utils/number'
import { MATCH_LOAD_DATA } from '@/store/types'

export const dbGLTransactionAjaxMixin = {
  data() {
    return {
      actionName: ''
    }
  },
  methods: {
    async debitNoteGLTransList() {
      this.loading = true
      const apiUrl = this.$store.state.debitNote.menu.debitNoteGLTransList
      if (apiUrl) {
        try {
          const expand = {
            branch: this.debitNoteData.branch,
            accountNo: this.debitNoteData.accountNo,
            transactionType: this.debitNoteData.type,
            documentNo: this.debitNoteData.documentNo,
            fund: this.debitNoteData.fund,
            accountNoSuffix: this.debitNoteData.suffix,
            gstAmtAE: this.debitNoteData.gstAmountAE,
            gstAmt: this.debitNoteData.gstAmount,
            netLocAmtAE: this.debitNoteData.netLocAmountAE,
            netLocAmt: this.debitNoteData.netLocAmount
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result

          if (data.data.length > 0) {
            data.data.map(glDetail => {
              const glDetailList = {
                glInterface: glDetail.glInterface,
                glAccountNo: glDetail.glAcctNo,
                description: glDetail.desc,
                curr: glDetail.currency,
                amount: formatPrice(glDetail.amount),
                localAmount: formatPrice(glDetail.localAmount),
                gstStatus: glDetail.gstStatus,
                gstRate: formatPrice(glDetail.gstRate),
                gstAmount: formatPrice(glDetail.gstAmount),
                deleteData: false,
                resultStatus: glDetail.resultStatus,
                branch: glDetail.branch,
                fund: glDetail.fund,
                accountNoSuffix: glDetail.accountNoSuffix,
                mixGlAccountNo: glDetail.glAcctNoMix,
                itemNo: glDetail.itemNo
              }
              this.itemsGL.push(glDetailList)
              // this.calculateRemainAmount(glDetail)
            })
            this.loading = false
            this.calculateRemainAmount()
          }
          var errMsg
          var messages = []

          for (var i = 0; i < this.itemsGL.length; i++) {
            if (this.itemsGL[i].resultStatus !== '') {
              messages.push({ message: this.itemsGL[i].resultStatus, type: 'ERROR' })
            }
          }
          errMsg = { messages }

          this.message(errMsg)
          this.fieldMessage(errMsg)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    calculateRemainAmount() {
      this.glListingForm.remainAmountToPost = '0.00'
      this.glListingForm.gstRemainAmount = '0.00'
      this.glListingForm.totalLocalAmount = '0.00'

      for (var i = 0; i < this.itemsGL.length; i++) {
        this.glListingForm.remainAmountToPost = formatPrice(
          Number(removeFormatNumber(this.glListingForm.remainAmountToPost)) - Number(removeFormatNumber(this.itemsGL[i].amount))
        )
        this.glListingForm.totalLocalAmount = formatPrice(
          Number(removeFormatNumber(this.glListingForm.totalLocalAmount)) + Number(removeFormatNumber(this.itemsGL[i].localAmount))
        )
        this.glListingForm.gstRemainAmount = formatPrice(
          Number(removeFormatNumber(this.glListingForm.gstRemainAmount)) - Number(removeFormatNumber(this.itemsGL[i].gstAmount))
        )
        if (this.itemsGL[i].glInterface === '6002' || this.itemsGL[i].glInterface === '6003') {
          this.glListingForm.gstRemainAmount = formatPrice(
            Number(removeFormatNumber(this.glListingForm.gstRemainAmount)) + Number(removeFormatNumber(this.itemsGL[i].amount))
          )
        }
      }

      if ((Number(removeFormatNumber(this.glListingForm.totalLocalAmount)) === 0.01 ||
        Number(removeFormatNumber(this.glListingForm.totalLocalAmount)) === -0.01) &&
        Number(removeFormatNumber(this.glListingForm.remainAmountToPost)) === 0 &&
        Number(removeFormatNumber(this.glListingForm.gstRemainAmount)) === 0) {
        this.glListingForm.totalLocalAmount = '0.00'
      } else if (
        Number(removeFormatNumber(this.glListingForm.totalLocalAmount)) === 0 &&
        (Number(removeFormatNumber(this.glListingForm.remainAmountToPost)) === 0.01 ||
        Number(removeFormatNumber(this.glListingForm.remainAmountToPost)) === -0.01) &&
        Number(removeFormatNumber(this.glListingForm.gstRemainAmount)) === 0
      ) {
        this.glListingForm.remainAmountToPost = '0.00'
      } else if (
        Number(removeFormatNumber(this.glListingForm.totalLocalAmount)) === 0 &&
        Number(removeFormatNumber(this.glListingForm.remainAmountToPost)) === 0 &&
        (Number(removeFormatNumber(this.glListingForm.gstRemainAmount)) === 0.01 ||
        Number(removeFormatNumber(this.glListingForm.gstRemainAmount)) === -0.01)
      ) {
        this.glListingForm.gstRemainAmount = '0.00'
      }

      this.loading = false
    },
    async doSaveGLTrans(actionName) {
      const apiURI = this.$store.state.debitNote.menu.saveGLTrans
      if (apiURI) {
        try {
          const expand = {
            branch: this.debitNoteData.branch,
            accountNo: this.debitNoteData.accountNo,
            transactionType: this.debitNoteData.type,
            documentNo: this.debitNoteData.documentNo,
            fund: this.debitNoteData.fund,
            accountNoSuffix: this.debitNoteData.suffix,
            actionName: actionName,
            glDetailList: []
          }
          expand.glDetailList = this.itemsGL
          const result = await this.$http.post(apiURI, expand)

          const { data } = result
          if (data) {
            this.processingFlag = false
            this.notify(data)
            if (
              this.debitNoteData.printDoc === 'I' &&
              (this.debitNoteData.actionName === 'CREATE_SAVE_POST' ||
                this.debitNoteData.actionName === 'UPDATE_SAVE_POST' ||
                this.debitNoteData.actionName === 'CREATE_MATCH_LATER' ||
                this.debitNoteData.actionName === 'UPDATE_MATCH_LATER')
            ) {
              const commit = {
                branch: this.debitNoteData.branch,
                accountNo: this.debitNoteData.accountNo,
                type: this.debitNoteData.type,
                documentNo: this.debitNoteData.documentNo,
                fund: this.debitNoteData.fund,
                suffix: this.debitNoteData.suffix,
                actionName: this.debitNoteData.actionName,
                printDoc: this.debitNoteData.printDoc
              }
              this.doExportAcctDrNoteDoc(commit)
            }

            if (this.debitNoteData.actionName === 'CREATE_MATCH_NOW' || this.debitNoteData.actionName === 'UPDATE_MATCH_NOW') {
              this.doMatchNow(this.debitNoteData)
            } else {
              this.$router.push({ name: 'debitNote' })
            }
          }
        } catch (err) {
          const { data } = err.response
          this.showPromptLeave = true
          if (data) {
            this.processingFlag = false
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.showPromptLeave = true
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doMatchNow(data) {
      await Promise.all([this.$store.dispatch('matchingInit')])
      const commit = {
        action: 'M',
        branch: data.branch,
        acctNo: data.accountNo,
        type: data.type,
        docNo: data.documentNo,
        fund: data.fund,
        suffix: data.suffix,
        frmModule: 'AcctDbNote',
        printDoc: data.printDoc
      }
      this.$store.commit(MATCH_LOAD_DATA, commit)
      this.$router.push({ name: 'reviewMatchTransaction' })
    }
  },
  mixins: [MessageMixin]
}
